import { render, staticRenderFns } from "./ShowFeedback.vue?vue&type=template&id=4a8a4b8f&scoped=true"
import script from "./ShowFeedback.vue?vue&type=script&lang=js"
export * from "./ShowFeedback.vue?vue&type=script&lang=js"
import style0 from "./ShowFeedback.vue?vue&type=style&index=0&id=4a8a4b8f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a8a4b8f",
  null
  
)

export default component.exports